export default {
  title_one: 'Statistici de livrare în actualizare pentru „{{title}}"',
  title_few: 'Statisticile de livrare se actualizează pentru {{count}} campanii',
  title_other: 'Statistici de livrare în actualizare pentru {{count}} campanii',
  subtitle_pending:
    'Apple și Google confirmă recepțiile în aproximativ {{minutes}}m {{seconds}}s (în jurul orei {{time}}). Statisticile se vor actualiza automat.',
  subtitle_ready:
    'Recepțiile ar trebui să fie disponibile. Reîncărcați pagina pentru a vedea cele mai recente date de livrare.',
};
